// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/root.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$(),
  _s2 = $RefreshSig$(),
  _s3 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/root.tsx");
  import.meta.hot.lastModified = "1744085769114.8093";
}
// REMIX HMR END

import * as React from "react";
import { Links, LiveReload, Meta, Outlet, useLocation, Scripts, ScrollRestoration, useRouteError, isRouteErrorResponse } from "@remix-run/react";
import { withEmotionCache } from "@emotion/react";
import { unstable_useEnhancedEffect as useEnhancedEffect } from "@mui/material";
import { ThemeToggleProvider } from "./src/ThemeContext";
import ClientStyleContext from "./src/ClientStyleContext";
import Layout from "./src/Layout";
import CssBaseline from "@mui/material/CssBaseline";
const Document = _s(withEmotionCache(_c = _s(({
  children,
  title
}, emotionCache) => {
  _s();
  const clientStyleData = React.useContext(ClientStyleContext);

  // Only executed on client
  useEnhancedEffect(() => {
    // re-link sheet container
    emotionCache.sheet.container = document.head;
    // re-inject tags
    const tags = emotionCache.sheet.tags;
    emotionCache.sheet.flush();
    tags.forEach(tag => {
      // eslint-disable-next-line no-underscore-dangle
      emotionCache.sheet._insertTag(tag);
    });
    // reset cache to reapply global styles
    clientStyleData.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <html lang="en">
        <head>
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width,initial-scale=1" />
          {title ? <title>{title}</title> : null}
          <Meta />
          <Links />
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
          <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap" />
          <meta name="emotion-insertion-point" content="emotion-insertion-point" />
        </head>
        <body>
          {children}
          <ScrollRestoration />
          <Scripts />
          <LiveReload />
        </body>
      </html>;
}, "DLeJk/J5GiFhAF52FJ/3oWg5qx4=", false, function () {
  return [useEnhancedEffect];
})), "DLeJk/J5GiFhAF52FJ/3oWg5qx4=", false, function () {
  return [useEnhancedEffect];
});
_c2 = Document;
export default function App() {
  _s2();
  const location = useLocation();

  // Specify routes where the layout should not be rendered
  const noLayoutRoutes = ["/login", "/signup"]; // Add more routes as needed

  // Check if the current path is in the list of noLayoutRoutes
  const shouldRenderLayout = !noLayoutRoutes.includes(location.pathname);
  return <ThemeToggleProvider>
      <Document>
        <CssBaseline />
        {shouldRenderLayout ? <Layout>
            <Outlet />
          </Layout> : <Outlet />}
      </Document>
    </ThemeToggleProvider>;
}
_s2(App, "pkHmaVRPskBaU4tMJuJJpV42k1I=", false, function () {
  return [useLocation];
});
_c3 = App;
export function ErrorBoundary() {
  _s3();
  const error = useRouteError();
  if (isRouteErrorResponse(error)) {
    let message;
    switch (error.status) {
      case 401:
        message = <p>
            Oops! Looks like you tried to visit a page that you do not have
            access to.
          </p>;
        break;
      case 404:
        message = <p>Oops! Looks like you tried to visit a page that does not exist.</p>;
        break;
      default:
        throw new Error(error.data || error.statusText);
    }
    return <ThemeToggleProvider>
        <Document title={`${error.status} ${error.statusText}`}>
          <Layout>
            <h1>
              {error.status}: {error.statusText}
            </h1>
            {message}
          </Layout>
        </Document>
      </ThemeToggleProvider>;
  }
  if (error instanceof Error) {
    console.error(error);
    return <ThemeToggleProvider>
        <Document title="Error!">
          <Layout>
            <div>
              <h1>There was an error</h1>
              <p>{error.message}</p>
              <hr />
              <p>
                Hey, developer, you should replace this with what you want your
                users to see.
              </p>
            </div>
          </Layout>
        </Document>
      </ThemeToggleProvider>;
  }
  return <h1>Unknown Error</h1>;
}
_s3(ErrorBoundary, "oAgjgbJzsRXlB89+MoVumxMQqKM=", false, function () {
  return [useRouteError];
});
_c4 = ErrorBoundary;
var _c, _c2, _c3, _c4;
$RefreshReg$(_c, "Document$withEmotionCache");
$RefreshReg$(_c2, "Document");
$RefreshReg$(_c3, "App");
$RefreshReg$(_c4, "ErrorBoundary");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;